import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
    cached: {},
}

export const getters = {}

export const mutations = {
    ACCESS_POINTS(state, access_points) {
        state.cached = access_points
    },
}

export const actions = {

    init({ state, dispatch }) { },

    fetchAccessPoints(context, query) {
        query = query || ''
        return axios.get(`${serverUrl}/app/access_point/${query}`).then((response) => {
            context.commit('ACCESS_POINTS', response.data.results)
            return response
        })
    },

    // fetchParticipantsOptions(context, query) {
    //     query = query || ''
    //     return axios.get(`${serverUrl}/api/masters/participants/options/${query}`).then((response) => {
    //         return response.data
    //     })
    // },

    // fetchParticipantsDetail(context, id) {
    //     return axios.get(`${serverUrl}/api/masters/participants/${id}/`).then((response) => {
    //         return response.data
    //     })
    // },

    // fetchParticipantByIdentification(context, identification) {
    //     return axios.get(`${serverUrl}/api/masters/participants/get_by_identification/?identification=${identification}`).then((response) => {
    //         return response.data
    //     })
    // },

    createUpdateAccessPoints(context, formData) {
        let promise = null
        if (formData.id) {
            promise = axios.put(`${serverUrl}/app/access_points/${formData.id}/`, formData)
        } else {
            promise = axios.post(`${serverUrl}/app/access_points`, formData)
        }
        return promise.then(
            (response) => {
                return response.data
            }
        )
    },

    deleteAccessPoints(context, _id) {
        let promise = null
        promise = axios.delete(`${serverUrl}/app/access_points/${_id}`)
        return promise.then(
            (response) => {
                return response.data
            }
        )
    },



}